import {
  MenuSelect,
  NoResults,
  Pagination,
  SearchBox,
  WhiteInstantSearchBuilder,
} from '@white-nl/instantsearch-components';
import { Hit, Loading } from '../../components/press/results';
import { ClearIndicator, DropdownIndicator } from '../../components/ui/view/React-select';
import { addDefaultItem } from '../../utils/TransformUtils';

import './press-images-overview.css';

const settings = document.getElementById('press-images')?.dataset || null;
const whiteInstantSearchCatalog = new WhiteInstantSearchBuilder();
if (settings) {
  const apiUrl = window.Craft.getSiteUrl('api/react/press-images');

  settings.type = settings.type ?? 'public';

  fetch(apiUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => res.json())
    .then((data) => {
      const {
        translates,
      } = data;

      const {
        pressImages,
        pagination,
      } = translates;

      whiteInstantSearchCatalog
        .withSearchkit(
          settings.indexName,
          settings.publicUrl || '',
          settings.jwt || '',
          settings.refreshUrl || '',
        )
        .withWhiteInstantSearchRouting({
          baseUrl: settings.baseUrl,
          addTrailingSlashesToUrls: window.Craft.trailingSlashes,
          writeDelay: 0,
        })
        .addAdditionalData({
          type: settings.type,
        });

      if (settings.type === 'private') {
        whiteInstantSearchCatalog
          .addSearchingComponent([
            {
              settings: {
                placeholder: window.Craft.t(pressImages, 'Search for press images', {}),
              },
              component: SearchBox,
            },
          ])
          .addMenu(
            [{
              settings: {
                attribute: 'galleries',
                limit: 999,
                classNames: {
                  control: () => 'dropdown-select',
                  menu: () => 'dropdown-list',
                },
                isSearchable: false,
                isClearable: true,
                unstyled: true,
                components: {
                  ClearIndicator,
                  DropdownIndicator,
                },
                transformItems: (items) => addDefaultItem(items, window.Craft.t(pressImages, 'All galleries', {})),
                translations: {
                  defaultOptionText: window.Craft.t(pressImages, 'All galleries', {}),
                },
              },
              component: MenuSelect,
            },
            ],
            '#white-instant-refinements-galleries',
          )
          .addMenu(
            [{
              settings: {
                attribute: 'categories',
                limit: 999,
                classNames: {
                  control: () => 'dropdown-select',
                  menu: () => 'dropdown-list',
                },
                isSearchable: false,
                isClearable: true,
                unstyled: true,
                components: {
                  ClearIndicator,
                  DropdownIndicator,
                },
                transformItems: (items) => addDefaultItem(items, window.Craft.t(pressImages, 'All categories', {})),
                translations: {
                  defaultOptionText: window.Craft.t(pressImages, 'All categories', {}),
                },
              },
              component: MenuSelect,
            },
            ],
            '#white-instant-refinements-categories',
          )
          .addMenu(
            [{
              settings: {
                attribute: 'periods',
                limit: 999,
                classNames: {
                  control: () => 'dropdown-select',
                  menu: () => 'dropdown-list',
                },
                isSearchable: false,
                isClearable: true,
                unstyled: true,
                components: {
                  ClearIndicator,
                  DropdownIndicator,
                },
                transformItems: (items) => addDefaultItem(items, window.Craft.t(pressImages, 'All periods', {})),
                translations: {
                  defaultOptionText: window.Craft.t(pressImages, 'All periods', {}),
                },
              },
              component: MenuSelect,
            },
            ],
            '#white-instant-refinements-periods',
          )
          .addMenu(
            [{
              settings: {
                attribute: 'artists',
                limit: 999,
                classNames: {
                  control: () => 'dropdown-select',
                  menu: () => 'dropdown-list',
                },
                isSearchable: false,
                isClearable: true,
                unstyled: true,
                components: {
                  ClearIndicator,
                  DropdownIndicator,
                },
                transformItems: (items) => addDefaultItem(items, window.Craft.t(pressImages, 'All artists', {})),
                translations: {
                  defaultOptionText: window.Craft.t(pressImages, 'All artists', {}),
                },
              },
              component: MenuSelect,
            },
            ],
            '#white-instant-refinements-artists',
          );
        if (settings.fair) {
          whiteInstantSearchCatalog.whereQuery(`fair="${settings.fair}"`);
        }
      } else {
        whiteInstantSearchCatalog
          .addMenu(
            [{
              settings: {
                attribute: 'fair',
                limit: 999,
                classNames: {
                  control: () => 'dropdown-select',
                  menu: () => 'dropdown-list',
                },
                isSearchable: false,
                isClearable: true,
                unstyled: true,
                components: {
                  ClearIndicator,
                  DropdownIndicator,
                },
                transformItems: (items) => addDefaultItem(items, window.Craft.t(pressImages, 'All fairs', {})),
                translations: {
                  defaultOptionText: window.Craft.t(pressImages, 'All fairs', {}),
                },
              },
              component: MenuSelect,
            },
            ],
            '#white-instant-refinements',
          );
      }
      whiteInstantSearchCatalog
        .addHitComponent(
          [
            {
              settings: {
                noResults: {
                  translations: {
                    noResults: window.Craft.t(pressImages, 'Sorry, we can\'t find any content!', {}),
                    refinements: window.Craft.t(pressImages, 'Try to choose another category or filter.', {}),
                    query: window.Craft.t(pressImages, 'Please try another query.', {}),
                  },
                },
              },
              component: Hit,
              loadingComponent: Loading,
              noResultsComponent: NoResults,
            },
          ],
          '#white-instant-search-hits',
        )
        .setHitsPerPage(12)
        .addPaginationComponent([
          {
            settings: {
              classNames: {
                noRefinementRoot: 'hidden',
                list: 'pagination-list',
                pageItem: 'pagination-item',
                link: 'pagination-link',
                previousPageItem: 'pagination-link pagination-link-prev',
                selectedItem: 'active',
                disabledItem: 'disabled',
                nextPageItem: 'pagination-link pagination-link-next',
              },
              translations: {
                previousPageItemText: window.Craft.t(pagination, 'Previous', {}),
                nextPageItemText: window.Craft.t(pagination, 'Next', {}),
              },
              showFirst: false,
              showLast: false,
            },
            component: Pagination,
          }])
        .setScrolling({
          includeAttributes: ['page'],
        });

      whiteInstantSearchCatalog
        .build()
        .show();
    });
}
